import { Play } from "lucide-react";
import type { FC } from "react";

import { cn } from "@/lib/utils";

type Props = {
  /** `lg` over the player, `md` over the toast card's poster. */
  size?: "md" | "lg";
};

/**
 * The round black play button centered on a tutorial's poster, as on
 * cursor.com/learn. Darkens when an ancestor `group/play` is hovered and
 * rings when it's focused.
 */
export const PlayDisc: FC<Props> = ({ size = "lg" }) => (
  <span
    aria-hidden
    className={cn(
      "flex items-center justify-center rounded-full bg-black text-white transition-colors duration-150 group-hover/play:bg-black/80 group-focus-visible/play:ring-2 group-focus-visible/play:ring-white/60",
      size === "lg" ? "size-16" : "size-11"
    )}
  >
    <Play
      className={cn(
        "fill-current",
        size === "lg" ? "ml-1 size-7" : "ml-0.5 size-5"
      )}
    />
  </span>
);
